const gk_downloads = {
  load() {},
};

export default gk_downloads;
